import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as firebase from "firebase/app";

export default {
  name: "AddLifestyleProgramCategoryDialog",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isEdit: false,
      colorMenu: false,
      isColorValid: null,
      category: {
        name: null,
        color: '#FFFFFF'
      },
      categoryCopy: null
    }
  },
  methods: {
    open(category) {
      if (category) {
        this.category = { ...category }
        this.categoryCopy = { ...category }
        this.categoryCopy.color = this.categoryCopy.color ? this.categoryCopy.color : this.category.color
        this.isEdit = true
      }
      this.dialog = true;
    },
    async upsertCategory() {

      const form = this.$refs.addCategoryForm as any;
      const validated = form.validate();
      if (!validated || !this.validateColor(this.category.color)) return;

      if (this.isEdit && this.categoryCopy.name == this.category.name && this.categoryCopy.color == this.category.color) {
        this.close()
        return
      }

      this.loading = true

      if (this.isEdit) {
        const isExistsByName = await this.isExistsByName(this.category.name, this.category.id)
        if (isExistsByName) {
          this.$refs.observer.setErrors({ Name: [this.$t('GeneralTranslations.NameAlreadyExists')] });
          this.loading = false
          return
        }
        else {
          await this.$store.dispatch('updateLifestyleProgramCategory', this.category)

          await this.$store.dispatch("updateServicesRequestsCategory", {
            categoryId: this.category.id,
            oldCategory: this.categoryCopy.name,
            newCategory: this.category.name
          })

          await this.$store.dispatch("updateAdditionalServicesCategory", {
            categoryId: this.category.id,
            newCategory: this.category.name
          })
        }
      }
      else {
        const isExistsByName = await this.isExistsByName(this.category.name)
        if (isExistsByName) {
          this.$refs.observer.setErrors({ Name: [this.$t('GeneralTranslations.NameAlreadyExists')] });
          this.loading = false
          return
        } else {
          await this.$store.dispatch('addLifestyleProgramCategory', this.category)
        }
      }
      this.close()
    },

    async isExistsByName(name, skipId) {
      let query = firebase.firestore().collection("lifestyleProgramCategories")
        .where("facilityId", "==", this.facility.id)
        .where("name", "==", name)

      if (skipId) {
        query = query.where(firebase.firestore.FieldPath.documentId(), '!=', skipId)
      }

      const docs = await query.get()

      return docs.size > 0
    },

    setCategoryColor(event) {
      this.category.color = event.hex || event;

      this.validateColor(this.category.color)
    },

    validateColor(color){
      if(!color || color === '#FFFFFF'){
        this.isColorValid = false
      }
      else{
        this.isColorValid = true
      }

      return this.isColorValid
    },

    close() {
      this.dialog = false
      this.isEdit = false
      this.loading = false
      this.category.name = null
      this.category.color = '#FFFFFF'
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    swatchStyle() {
      const style = {
        backgroundColor: this.category.color || '#FFFFFF',
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '100%',
        transition: 'border-radius 200ms ease-in-out'
      }
      return style
    }
  }
}